const roundCurrency = (value) => Math.round((value + Number.EPSILON) * 100) / 100;

export const PLAN_CURRENCIES = ['GBP', 'EUR', 'BRL'];

export const convertPlanAmountToGBP = (amount, currency, conversionRates = {}) => {
  const numericAmount = Number(amount) || 0;
  if (currency === 'EUR') return numericAmount / (Number(conversionRates.EUR) || 1.165);
  if (currency === 'BRL') return numericAmount / (Number(conversionRates.BRL) || 6.36);
  return numericAmount;
};

export const calculateExpensePlan = (plan, categories = [], conversionRates = {}) => {
  const categoryBudgets = Object.fromEntries(categories.map(category => [category, 0]));

  (plan?.items || []).forEach(item => {
    if (!Object.prototype.hasOwnProperty.call(categoryBudgets, item.category)) return;
    const amount = convertPlanAmountToGBP(item.amount, item.currency, conversionRates);
    categoryBudgets[item.category] = roundCurrency(categoryBudgets[item.category] + amount);
  });

  const monthlyExpenses = roundCurrency(
    Object.values(categoryBudgets).reduce((total, amount) => total + amount, 0)
  );
  const salary = roundCurrency(convertPlanAmountToGBP(
    plan?.salary,
    plan?.salaryCurrency,
    conversionRates
  ));
  const monthlyBalance = roundCurrency(salary - monthlyExpenses);

  return {
    salary,
    categoryBudgets,
    monthlyExpenses,
    monthlyBalance,
    annualBalance: roundCurrency(monthlyBalance * 12),
  };
};

export const normalizeExpensePlan = (value, fallback) => {
  const source = value && typeof value === 'object' ? value : fallback;
  const items = Array.isArray(source?.items) ? source.items : [];

  return {
    active: Boolean(source?.active),
    salary: Number(source?.salary) || 0,
    salaryCurrency: PLAN_CURRENCIES.includes(source?.salaryCurrency) ? source.salaryCurrency : 'GBP',
    items: items.map((item, index) => ({
      id: String(item?.id || `plan-item-${index + 1}`),
      name: String(item?.name || ''),
      category: String(item?.category || 'BILLS'),
      amount: Number(item?.amount) || 0,
      currency: PLAN_CURRENCIES.includes(item?.currency) ? item.currency : 'GBP',
    })),
  };
};
